export const FETCH_CARD = 'FETCH_CARD';
export const FETCH_NEXT_CARD = 'FETCH_NEXT_CARD';
